import React, { useEffect, useState } from 'react';
import './style.scss';
import { Editor } from '../../components/Editor';
import { useParams } from 'react-router-dom';
import firebase from '../../firebase';

const VideoEditor = () => {
  const { id } = useParams();
  const [{ config, url }, setData] = useState({});
  var db = firebase.firestore();

  useEffect(() => {
    var docRef = db.collection('videos').doc(id);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          const data = doc.data();
          console.log('Document data:', doc.data());
          setData({
            url: data.url,
            config: JSON.parse(data.config),
          });
        } else {
          console.log('No such document!');
        }
      })
      .catch(function (error) {
        console.log('Error getting document:', error);
      });

    return () => {};
  }, []);

  return config && url ? (
    <Editor
      id={id}
      src={url}
      config={config}
      onSave={({ config, url }, callback) => {
        db.collection('videos')
          .doc(id)
          .update({
            config: JSON.stringify(config),
            url: url,
          })
          .then(callback);
      }}
    />
  ) : (
    <span />
  );
};

export default VideoEditor;
